import React from 'react';
import { TopicStyles } from './mixins/mixins';
import { StyleToggle } from './components/common';

export const FeaturesStyle = ({
	style,
	setStyle
}: {
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
}) => {
	return (
		<div className="grid grid-cols-2 lg:grid-cols-3 justify-items-center gap-4">
			<StyleToggle
				key={'features_bookmarks'}
				style={style}
				styleObj={'featuresStyle'}
				parentStyle={style.featuresStyle}
				styleKey={'bookmarks'}
				name={'Bookmarks'}
				optionState={style.featuresStyle.bookmarks}
				setStyle={setStyle}
			/>

			<StyleToggle
				key={'features_time'}
				style={style}
				styleObj={'featuresStyle'}
				parentStyle={style.featuresStyle}
				styleKey={'time'}
				name={'Time'}
				optionState={style.featuresStyle.time}
				setStyle={setStyle}
			/>

			<StyleToggle
				key={'features_date'}
				style={style}
				styleObj={'featuresStyle'}
				parentStyle={style.featuresStyle}
				styleKey={'date'}
				name={'Date'}
				optionState={style.featuresStyle.date}
				setStyle={setStyle}
			/>

			<StyleToggle
				key={'features_integrations'}
				style={style}
				styleObj={'featuresStyle'}
				parentStyle={style.featuresStyle}
				styleKey={'integrations'}
				name={'Integrations'}
				optionState={style.featuresStyle.integrations}
				setStyle={setStyle}
			/>

			<StyleToggle
				key={'features_notes'}
				style={style}
				styleObj={'featuresStyle'}
				parentStyle={style.featuresStyle}
				styleKey={'notes'}
				name={'Notes'}
				optionState={style.featuresStyle.notes}
				setStyle={setStyle}
			/>

			<StyleToggle
				key={'features_quote'}
				style={style}
				styleObj={'featuresStyle'}
				parentStyle={style.featuresStyle}
				styleKey={'quote'}
				name={'Quote'}
				optionState={style.featuresStyle.quote}
				setStyle={setStyle}
			/>

			<StyleToggle
				key={'features_searchbar'}
				style={style}
				styleObj={'featuresStyle'}
				parentStyle={style.featuresStyle}
				styleKey={'searchBar'}
				name={'Searchbar'}
				optionState={style.featuresStyle.searchBar}
				setStyle={setStyle}
			/>

			<StyleToggle
				key={'features_weather'}
				style={style}
				styleObj={'featuresStyle'}
				parentStyle={style.featuresStyle}
				styleKey={'weather'}
				name={'Weather'}
				optionState={style.featuresStyle.weather}
				setStyle={setStyle}
			/>
		</div>
	);
};
